import type { Editor } from '@tiptap/react';
import {
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiChevronUp,
  FiTrash,
  FiTrash2,
  FiType,
} from 'react-icons/fi';
import { ToolbarButton, toolbarIconClass } from './toolbar-controls';

type TableControlsProps = { editor: Editor; isDisabled: boolean };

/** Row operations for the table under the cursor. */
export function RowControls({ editor, isDisabled }: TableControlsProps) {
  return (
    <>
      <ToolbarButton
        label="Add row above"
        disabled={isDisabled || !editor.can().addRowBefore()}
        onClick={() => editor.chain().focus().addRowBefore().run()}
      >
        <FiChevronUp className={toolbarIconClass} aria-hidden="true" />
      </ToolbarButton>
      <ToolbarButton
        label="Add row below"
        disabled={isDisabled || !editor.can().addRowAfter()}
        onClick={() => editor.chain().focus().addRowAfter().run()}
      >
        <FiChevronDown className={toolbarIconClass} aria-hidden="true" />
      </ToolbarButton>
      <ToolbarButton
        label="Delete row"
        disabled={isDisabled || !editor.can().deleteRow()}
        onClick={() => editor.chain().focus().deleteRow().run()}
      >
        <FiTrash2 className={toolbarIconClass} aria-hidden="true" />
      </ToolbarButton>
    </>
  );
}

/** Column operations for the table under the cursor. */
export function ColumnControls({ editor, isDisabled }: TableControlsProps) {
  return (
    <>
      <ToolbarButton
        label="Add column before"
        disabled={isDisabled || !editor.can().addColumnBefore()}
        onClick={() => editor.chain().focus().addColumnBefore().run()}
      >
        <FiChevronLeft className={toolbarIconClass} aria-hidden="true" />
      </ToolbarButton>
      <ToolbarButton
        label="Add column after"
        disabled={isDisabled || !editor.can().addColumnAfter()}
        onClick={() => editor.chain().focus().addColumnAfter().run()}
      >
        <FiChevronRight className={toolbarIconClass} aria-hidden="true" />
      </ToolbarButton>
      <ToolbarButton
        label="Delete column"
        disabled={isDisabled || !editor.can().deleteColumn()}
        onClick={() => editor.chain().focus().deleteColumn().run()}
      >
        <FiTrash2 className={toolbarIconClass} aria-hidden="true" />
      </ToolbarButton>
    </>
  );
}

/** Header toggle and the one destructive action. */
export function TableHeaderControls({ editor, isDisabled }: TableControlsProps) {
  return (
    <>
      <ToolbarButton
        label="Toggle header row"
        pressed={editor.isActive('tableHeader')}
        disabled={isDisabled || !editor.can().toggleHeaderRow()}
        onClick={() => editor.chain().focus().toggleHeaderRow().run()}
      >
        <FiType className={toolbarIconClass} aria-hidden="true" />
      </ToolbarButton>
      <ToolbarButton
        label="Delete table"
        variant="danger"
        disabled={isDisabled || !editor.can().deleteTable()}
        onClick={() => editor.chain().focus().deleteTable().run()}
      >
        <FiTrash className={toolbarIconClass} aria-hidden="true" />
      </ToolbarButton>
    </>
  );
}
